import { FC } from "react";
import { CourseCard } from "./components/CourseCard";
import { COURSES_DATA, CourseData, PricingOption } from "./types";
import { admissionModel } from "widgets/admission";
import { popoutModel } from "shared/ui/popout-root";
import styles from './styles.module.scss';

export const Courses: FC = () => {
    const handleCourseSelect = (course: CourseData, pricing?: PricingOption) => {
        // Сбрасываем предыдущие выборы
        admissionModel.events.setPricingSelect(null);
        admissionModel.events.setTrainingSelect(null);
        
        // Устанавливаем выбранный курс с полной информацией
        admissionModel.events.setCourseSelect({
            name: course.title,
            courseData: course,
            pricingOption: pricing || null
        });

        console.log('Выбран курс:', {
            course: course.title,
            duration: course.duration,
            frequency: course.frequency,
            pricing: pricing
        });

        if (pricing) {
            // Если выбрана конкретная цена - сохраняем её и переходим к заявке
            console.log('Выбрана опция:', {
                course: course.title,
                format: pricing.format,
                type: pricing.type,
                price: pricing.price
            });

            // Сохраняем выбранную опцию цены
            admissionModel.events.setPricingSelect({
                format: pricing.format,
                type: pricing.type,
                price: pricing.price
            });

            // Автоматически устанавливаем соответствующий TTraing для совместимости (если нужно)
            const trainingId = `${pricing.format}_${pricing.type === 'individual' ? '1' : pricing.type === 'closed_group' ? '2' : '3'}` as any;
            admissionModel.events.setTrainingSelect({ id: trainingId });
            
            // Переходим к заявке, минуя TypeTraining
            popoutModel.events.setPopout('admission');
        } else {
            // Если курс с особым предложением или просто кликнули на карточку
            if (course.pricing.length > 0) {
                // У курса есть варианты цен, но конкретная опция не выбрана
                // Это означает что пользователь кликнул на основную карточку
                // Панель выбора откроется внутри карточки
                return;
            } else {
                // Курс с особым предложением - сразу к заявке
                popoutModel.events.setPopout('admission');
            }
        }
    };

    return (
        <div className={styles.courses} id="courses">
            <div className={styles.__in}>
                <div className={styles.title}>
                    Учим IT-профессиям на практике
                </div>

                <div className={styles.sub_title}>
                    Эксперты из IT-индустрии разрабатывают курсы и поддерживают вас на всем пути
                </div>

                <div className={styles.list}>
                    {COURSES_DATA.map((course) => (
                        <CourseCard
                            key={course.id}
                            course={course}
                            onSelectCourse={handleCourseSelect}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};